import {
  ApolloLink,
  Observable,
} from 'apollo-link';

class ApolloErrorLink extends ApolloLink {
  emitter;

  errorCallback;

  constructor(emitter, errorCallback) {
    super();
    this.emitter = emitter;
    this.errorCallback = errorCallback;
  }

  request(operation, forward) {
    const subscriber = forward(operation);

    const { useLocalError } = operation.getContext();

    return new Observable((observer) => {
      const subscription = subscriber.subscribe({
        next: (result) => {
          if (result.errors) {
            if (!useLocalError) {
              const graphQLErrors = result.errors;
              this.emitter.emit(graphQLErrors);
              this.errorCallback(graphQLErrors);
              return;
            }
          }
          observer.next(result);
        },
        error: (networkError) => {
          if (!useLocalError) {
            this.emitter.emit(networkError);
            this.errorCallback(networkError);
            return;
          }
          observer.error(networkError);
        },
        complete: observer.complete.bind(observer),
      });

      return () => {
        if (subscription) subscription.unsubscribe();
      };
    });
  }
}

export default ApolloErrorLink;
